import { render, staticRenderFns } from "./rankingOverview.vue?vue&type=template&id=6ac1f2af&scoped=true"
import script from "./rankingOverview.vue?vue&type=script&lang=js"
export * from "./rankingOverview.vue?vue&type=script&lang=js"
import style0 from "./rankingOverview.vue?vue&type=style&index=0&id=6ac1f2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1f2af",
  null
  
)

export default component.exports